<template>
  <div>
    <b-form-group
      label="Başlık"
      label-for="title"
    >
      <validation-provider
        #default="{ errors }"
        name="Başlık"
        rules="required"
      >
        <b-form-input
          id="title"
          v-model="itemData.title"
          placeholder="Başlık"
          :readonly="!!itemData.locked"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <b-form-group
      label="Özet"
      label-for="summary"
      description="Sayfa girişinde başlığın altında görünen kısa metin (Sürdürülebilirlik, Yedek Parça, KVKK)."
    >
      <b-form-textarea
        id="summary"
        v-model="itemData.summary"
        placeholder="Özet"
        rows="2"
        maxlength="500"
      />
    </b-form-group>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'TitleText',
  components: {
    BFormGroup,
    BFormInput,
    BFormTextarea,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['contents/dataItem']
    },
  },
}
</script>
